import React from 'react';
import classes from './InputField.module.scss'

const InputField = ({name , type , onChange , placeholder ,children ,style , value}) => {
    return (
        <div className={classes.InputFieldDiv} style={style}>
            <input className={classes.InputField} type={type} placeholder={placeholder} onChange={onChange} value={value}/>
            {children}
        </div>
    )
}

export default React.memo(InputField);